import {
  type FC,
  type HTMLInputTypeAttribute,
  type ReactNode,
  useId,
} from 'react'

import { FormControl, FormHelperText, FormLabel, Input } from 'base-ui'

import { type MarketplacePartnerRegisterPageFormState } from '../../marketplacePartnerRegisterPageMakeFormState'
import { useMarketplacePartnerRegisterPageContext } from '../marketplacePartnerRegisterPageContext'

type MarketplacePartnerRegisterPageFormInputFieldProps = {
  fieldName: keyof MarketplacePartnerRegisterPageFormState['model']
  label: ReactNode
  required?: boolean
  type?: HTMLInputTypeAttribute
}

export const MarketplacePartnerRegisterPageFormInputField: FC<
  MarketplacePartnerRegisterPageFormInputFieldProps
> = ({ fieldName, label, required = false, type = 'text' }) => {
  const { formState } = useMarketplacePartnerRegisterPageContext()
  const fieldId = useId()
  const { model } = formState
  formState.use()

  return (
    <FormControl
      {...formState.makeInputProps(fieldName, {
        validateOnBlur: true,
      })}
      data-qa-id={`sellerForm-formControl-${fieldName}`}
      error={!model.validator.isPropertyValid(fieldName)}
      onChange={(event) => {
        if (type === 'number') {
          const value = event.target.value ? Number(event.target.value) : ''
          formState.setValue(value, model, fieldName)
        } else {
          formState.setValue(event.target.value, model, fieldName)
        }
      }}
    >
      <FormLabel htmlFor={fieldId}>
        {label}
        {required ? '*' : ''}
      </FormLabel>
      {type === 'textarea' ? (
        <Input
          data-qa-id={`marketplace-partner-register-page-form-input-field-textarea-${fieldName}`}
          id={fieldId}
          multiline
          slotProps={{
            input: {
              'data-qa-id': `message-form-§emailForm.${fieldName}`,
            },
          }}
        />
      ) : (
        <Input
          data-qa-id={`marketplace-partner-register-page-form-input-field-input-${fieldName}`}
          id={fieldId}
          slotProps={{
            input: {
              'data-qa-id': `message-form-§emailForm.${fieldName}`,
            },
          }}
          type={type}
        />
      )}
      {model.validator.getFirstErrorFor(fieldName) && (
        <FormHelperText
          data-qa-id={`global-MessageForm-${fieldName}-error-msg`}
        >
          {model.validator.getFirstErrorFor(fieldName)}
        </FormHelperText>
      )}
    </FormControl>
  )
}
